import { render, staticRenderFns } from "./agentCopy.vue?vue&type=template&id=5f0b8f44&scoped=true"
import script from "./agentCopy.vue?vue&type=script&lang=js"
export * from "./agentCopy.vue?vue&type=script&lang=js"
import style0 from "./agentCopy.vue?vue&type=style&index=0&id=5f0b8f44&prod&scoped=true&lang=css"
import style1 from "./agentCopy.vue?vue&type=style&index=1&id=5f0b8f44&prod&lang=css"
import style2 from "./agentCopy.vue?vue&type=style&index=2&id=5f0b8f44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0b8f44",
  null
  
)

export default component.exports